import React from 'react';
import BaseTabComponent from './../BaseTabComponent';
import plusIcon from "../../../../svgs/plus-button.svg";
import minusIcon from "../../../../svgs/minus-button.svg";
import {getExpensesHeader} from "../../mt-fields-to-save";
import {analysisDateIndex, expensesHeaderIndex} from "../../UnderwritingMultiTenant";
import Icon from "../../../Icon";

export default class Pricing extends BaseTabComponent {
    constructor(props) {
        super(props);

        this.handleExpand = this.handleExpand.bind(this);
    }

    handleExpand(isAdditionalPrice) {
        if (isAdditionalPrice) {
            this.props.handleExpand({
                tabId: 'pricing-tab',
                tablesId: ['base-rent'],
                rowsId: {
                    'base-rent': ['additional-price'],
                },
            });
            this.props.setState({isAdditionalPriceVisible: !this.props.isAdditionalPriceVisible});
        } else {
            this.props.handleExpand({
                tabId: 'pricing-tab',
                tablesId: ['header', 'base-rent', 'exp-reimb', 'total-gross-revenue', 'expenses', 'net-operating-income', 'annual-debt-service', 'value', 'required-equity', 'loan-amount', 'interest-rate', 'proforma-capital-req'],
                rowsId: {
                    'base-rent': ['header', 'occupied-space', 'vacant-space'],
                },
                cellsId: [4, 5, 6, 7, 8]
            });
            this.props.setState({isProformaVisiblePricing: !this.props.isProformaVisiblePricing});
        }
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
        if (tableIdentifier === 'pricing-analysis' && rowCode === 'pricing-analysis' && columnIndex === analysisDateIndex)
            this.props.valuesChange({
                tabs: ['pricing-tab', 'expenses-tab'],
                tables: [tableIdentifier, 'expenses'],
                rowIds: [rowCode, 'header'],
                values: [event.currentTarget.value, getExpensesHeader({pricingAnalysis: event.currentTarget.value})],
                columnIds: [columnIndex, expensesHeaderIndex],
            });
        else
            this.props.valueChange('pricing-tab', tableIdentifier, rowCode, event.currentTarget.value, columnIndex);
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, hasProformaExpansion = false, nonReimbExpenses) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);

            if (tableIdentifier === 'expenses' && key === 'non-reimbursable-expenses' && !nonReimbExpenses)
                return;

            return <tr key={key} className={key}>
                {table.hasNamesColumn ? nameCell : null}

                {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }
                    if (cell.hidden) {
                        return;
                    }
                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index);
                    }
                    else {
                        const domKey = `${key}-${index}`;
                        return this.renderStaticValueCell(this.props.tabs, cell, domKey, precomputedValues);
                    }
                })}
            </tr>
        });

        return (
            <React.Fragment key={tableIdentifier}>
                <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                    <tbody>
                    {table.headerRow && table.headerRow.length ?
                        <tr>{table.headerRow.map((cell, index) => {
                            return (
                                <td className='header-cell' key={index}>
                                    <div className='text'>{cell}</div>
                                </td>
                            )
                        })}</tr>
                        : null
                    }

                    {tableRows}

                    {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                        <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                            const cell = table.footerRow.valueCells[key];
                            if (cell.hidden) {
                                return;
                            }
                            if (cell) {
                                return (
                                    <td key={key}>
                                        <div className='text'>{cell.getComputedValue(this.props.tabs, precomputedValues).displayValue}</div>
                                        {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
                                    </td>
                                );
                            }
                            return <td className='invisible' key={key}/>;
                        })}</tr>
                        : null
                    }
                    </tbody>
                </table>
                {
                    hasProformaExpansion &&
                    <div className={'Financials_table_expand_button'} dangerouslySetInnerHTML={{__html: (this.props.isProformaVisiblePricing ? minusIcon : plusIcon)}} onClick={() => this.handleExpand()}/>
                }
            </React.Fragment>
        )
    }

    renderStaticValueCell(tabs, cell, domKey, precomputedValues) {
        return (
            <td className={`value-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`} key={domKey}>
                <span className='text value'>{cell.getComputedValue(tabs, precomputedValues).displayValue}</span>
                {
                    cell.hasExpandButton &&
                    <span className='expand-button' onClick={() => this.handleExpand(true)}>
                        <Icon svg={this.props.isAdditionalPriceVisible ? minusIcon : plusIcon}/>
                    </span>
                }
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    render() {
        const tab = this.props.tabs['pricing-tab'];
        const generalInformation = this.props.tabs['property-information-tab'].tables['general-information'];
        const nonReimbExpenses = this.props.tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value;

        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(this.props.tabs);

        return (
            <div className="Pricing">
                <div className="Financials_table_container">
                    <h3 className="Financials_table_title">{generalInformation.rows['property-name'].value}</h3>
                    <div className="text">{generalInformation.rows['address'].value}</div>
                    <div className="text">{generalInformation.rows['city'].value}, {generalInformation.rows['state'].value}</div>
                </div>

                <div className='Financials_list_columns'>
                    <div className={`Financials_list_column ${this.props.isProformaVisiblePricing ? 'expanded' : ''}`}>
                        {BaseTabComponent.renderTableContainer(tab.tables['pricing-analysis'], [
                            this.renderMatrixTable(tab.tables, 'pricing-analysis', precomputedValues, true),
                            this.renderMatrixTable(tab.tables, 'header', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'base-rent', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'exp-reimb', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'total-gross-revenue', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'expenses', precomputedValues, null, nonReimbExpenses),
                            this.renderMatrixTable(tab.tables, 'net-operating-income', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'annual-debt-service', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'value', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'required-equity', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'loan-amount', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'interest-rate', precomputedValues),
                            this.renderMatrixTable(tab.tables, 'proforma-capital-req', precomputedValues),
                        ])}
                    </div>
                    <div className='Financials_list_column'>
                        {BaseTabComponent.renderTableContainer(tab.tables['pricing-sensitivity-matrix'], [
                            this.renderMatrixTable(tab.tables, 'pricing-sensitivity-matrix', precomputedValues),
                            this.renderTable(tab.tables, 'pricing-sensitivity-matrix-increase', precomputedValues)
                        ])}
                    </div>
                </div>
            </div>
        )
    }
}